/**
 * card-variant-selects.js
 * Add to /assets/ and load in theme.liquid before </body>:
 *   {{ 'card-variant-selects.js' | asset_url | script_tag }}
 */

(function () {
  'use strict';

  window.cardVariantSelectsLoaded = true;

  function shopifyImageUrl(url, width) {
    if (!url) return url;
    if (url.startsWith('//')) url = 'https:' + url;
    return url.replace(/(\.\w{2,6})(\?.*)?$/, '_' + width + 'x$1$2');
  }

  function buildSrcset(src, maxWidth) {
    var breakpoints = [165, 360, 533, 720, 940, 1066];
    return breakpoints
      .filter(function (w) { return w <= (maxWidth || 2048); })
      .map(function (w) { return shopifyImageUrl(src, w) + ' ' + w + 'w'; })
      .concat(src + ' ' + (maxWidth || 1066) + 'w')
      .join(', ');
  }

  function getVariants(pickerEl) {
    var el = pickerEl.querySelector('[data-product-variants]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); }
    catch (e) { return null; }
  }

  function getSelectedOptions(pickerEl) {
    var values = [];
    var fieldsets = pickerEl.querySelectorAll('fieldset.product-form__input');
    if (fieldsets.length) {
      fieldsets.forEach(function (fs) {
        var chk = fs.querySelector('input[type="radio"]:checked');
        if (chk) values.push(chk.value.trim());
      });
      return values;
    }
    pickerEl.querySelectorAll('select').forEach(function (s) { values.push(s.value.trim()); });
    return values;
  }

  function findCardImage(pickerEl) {
    // Your DOM (confirmed from debug):
    // .naTCard
    //   .card (div with no extra class)
    //     .card__inner   <-- IMAGE IS HERE
    //       .card__media
    //         img
    //     .card__content <-- PICKER IS HERE
    //       .card__information
    //         variant-selects

    var naTCard = pickerEl.closest('.naTCard');
    if (!naTCard) naTCard = pickerEl.closest('.card-wrapper');
    if (!naTCard) {
      console.warn('[CVS] Could not find .naTCard wrapper');
      return null;
    }

    var img = naTCard.querySelector('.card__inner .card__media img');
    if (img) { console.log('[CVS] Found img via .card__inner .card__media img'); return img; }

    img = naTCard.querySelector('.card__media img');
    if (img) { console.log('[CVS] Found img via .card__media img'); return img; }

    img = naTCard.querySelector('.card__inner img');
    if (img) { console.log('[CVS] Found img via .card__inner img'); return img; }

    // Last resort - first img in the card that isn't a swatch
    var allImgs = naTCard.querySelectorAll('img');
    for (var i = 0; i < allImgs.length; i++) {
      var src = allImgs[i].src || '';
      // Skip tiny swatch images (width < 100) and SVGs
      if (allImgs[i].offsetWidth > 100 || src.indexOf('cdn.shopify') > -1) {
        console.log('[CVS] Found img via last-resort scan, src:', src.slice(-50));
        return allImgs[i];
      }
    }

    console.warn('[CVS] No image found in .naTCard. All imgs:', Array.from(naTCard.querySelectorAll('img')).map(function(i){ return i.src.slice(-40); }));
    return null;
  }

  document.addEventListener('change', function (e) {
    var target = e.target;
    if (!target || (target.type !== 'radio' && target.tagName !== 'SELECT')) return;

    var pickerEl = target.closest('variant-selects');
    if (!pickerEl || pickerEl.dataset.cardMode !== 'true') return;

    var variants = getVariants(pickerEl);
    if (!variants) {
      console.warn('[CVS] No variants JSON found');
      return;
    }

    var opts = getSelectedOptions(pickerEl);
    console.log('[CVS] Selected options:', opts);
    console.log('[CVS] Variant options available:', variants.map(function(v){ return v.options; }));

    var matched = variants.find(function (v) {
      return v.options.every(function (o, i) {
        return o.trim() === (opts[i] || '').trim();
      });
    });

    console.log('[CVS] Matched variant:', matched ? matched.id : 'NONE');
    console.log('[CVS] Has featured_image:', matched ? !!matched.featured_image : 'N/A');

    if (!matched) return;

    var blob = pickerEl.querySelector('[data-selected-variant]');
    if (blob) blob.textContent = JSON.stringify(matched);

    pickerEl.querySelectorAll('[data-selected-value]').forEach(function (span) {
      var fs = span.closest('fieldset');
      if (!fs) return;
      var chk = fs.querySelector('input[type="radio"]:checked');
      if (chk) span.textContent = chk.value;
    });

    if (!matched.featured_image) {
      console.warn('[CVS] Matched variant has no featured_image - check Shopify product images are assigned to variants');
      return;
    }

    var img = findCardImage(pickerEl);
    if (!img) return;

    var fi = matched.featured_image;
    console.log('[CVS] Swapping image to:', fi.src.slice(-60));

    img.style.transition = 'opacity 0.15s ease';
    img.style.opacity = '0.5';
    img.src = shopifyImageUrl(fi.src, 533);
    img.srcset = buildSrcset(fi.src, fi.width);
    if (fi.alt) img.alt = fi.alt;
    img.onload = function () { img.style.opacity = '1'; };
    setTimeout(function () { img.style.opacity = '1'; }, 400);

  }, true);

})();